import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import { useError } from '@zenbusiness/application-commons-logging';

export const NEXTUP_QUERY = gql`
  query NextUpQuery($identity: CustomerIdentity!, $constraintOverrides: [ConstraintOverride]) {
    nextUpCards(identity: $identity, constraintOverrides: $constraintOverrides) {
      instanceUuid
      uuid
      inAppKey
      topic
      title
      description: subtitle
      ctaUrl
      ctaType
      image
      estimate
      tooltip
      readinessStatus
    }
  }
`;

export function useNextUp() {
  const { businessEntityUuid } = useBusinessEntity();
  const { accountUuid, userUuid } = useIdentity();

  const {
    data, loading, errors, refetch
  } = useQuery(NEXTUP_QUERY, {
    noThrow: true,
    skip: !businessEntityUuid || !accountUuid || !userUuid,
    useCache: false,
    variables: {
      identity: {
        businessEntityUuid,
        accountUuid,
        userUuid,
        inAppTypes: ['next-up']
      }
    }
  });

  useError(errors);

  return {
    data: data?.nextUpCards || [],
    error: errors?.[0],
    loading,
    refetch
  };
}
